// Widget-Plugin: Subdashboard
var vcDashboardPopup = (function ($) {

    function formatNumber(raw) {
        if (raw === null || raw === undefined) return "--";
        if (!raw && raw !== 0) return "--";
        var parts = raw.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return parts.length > 1 ? parts[0] + "," + parts[1] : parts[0];
    }

    function addSettingsButton($item, onClick) {
        var $settingsBtn = $("<div class='dashboard-settings-btn'><i class='fa-solid fa-gear color-font-secondary'></i></div>");
        $item.append($settingsBtn);
        $settingsBtn.on("click", function (e) {
            e.stopPropagation();
            onClick(e);
        });
        return $settingsBtn;
    }

    function open(options) {
        
        var title = options.title ;
        var currentSettings = options.settings || {};
        var fields = options.fields || [];
        var onSave = options.onSave || function () { };

        var layout = options.layout || "single";
        var $overlay = $("<div class='dashboard-settings-overlay'></div>");
        var $popup = $("<div class='dashboard-settings-popup'></div>");
        if (layout === "twocolumn") {
            $popup.addClass("dashboard-settings-popup--twocolumn");
            if (options.wide) $popup.addClass("dashboard-settings-popup--twocolumn-wide");
        } else if (options.wide) {
            $popup.addClass("dashboard-settings-popup--wide");
        }
        var $title = $("<div class='vc-list-header-simple vc-grid-margin-bottom '>" + title + "</div>");
        var $form = $("<div class='dashboard-settings-popup-form'></div>");
        var $formLeft, $formRight;
        if (layout === "twocolumn") {
            $form.addClass("dashboard-settings-popup-form--twocolumn");
            $formLeft = $("<div class='dashboard-settings-popup-form-col dashboard-settings-popup-form-col--left'></div>");
            $formRight = $("<div class='dashboard-settings-popup-form-col dashboard-settings-popup-form-col--right'></div>");
            $form.append($formLeft, $formRight);
        }

        var fieldElements = [];
        var signalListValidators = [];
        var richtextFields = [];

        $.each(fields, function (i, fieldDef) {
            var $row = $("<div class='dashboard-settings-popup-row'></div>").attr("data-field-index", i);
            var $label = $("<label class='dashboard-settings-popup-label'></label>").text(fieldDef.label != null ? fieldDef.label : fieldDef.key);
            var val = currentSettings[fieldDef.key];
            if (fieldDef.arrayIndex !== undefined && Array.isArray(val)) {
                val = val[fieldDef.arrayIndex] !== undefined ? val[fieldDef.arrayIndex] : null;
            }

            if (fieldDef.type === "searchselect") {
                var $searchWrapper = $("<div class='dashboard-searchselect-wrapper'></div>").css({ position: "relative", width: "100%" });
                var $hiddenInput = $("<input type='hidden'>").attr("data-key", fieldDef.key).attr("data-array-index", fieldDef.arrayIndex !== undefined ? fieldDef.arrayIndex : "").val(val || "");
                var $searchInput = $("<input class='dashboard-settings-popup-input dashboard-searchselect-input' type='text'>").attr({ placeholder: vcDashboardResources.get("search"), autocomplete: "off" }).css({ width: "100%", boxSizing: "border-box" });
                var $dropdown = $("<div class='dashboard-searchselect-dropdown'></div>").css({
                    position: "absolute", top: "100%", left: 0, right: 0, maxHeight: "200px",
                    overflowY: "auto", background: "#fff", border: "1px solid #555",
                    borderRadius: "4px", zIndex: 1000, display: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.4)"
                });

                var allOpts = fieldDef.options || [];
                // ensure a value is always selected
                var initialVal = val;
                if ((initialVal == null || initialVal === "") && allOpts.length > 0) {
                    initialVal = allOpts[0].value;
                }
                $hiddenInput.val(initialVal || "");
                $.each(allOpts, function (j, opt) {
                    if (opt.value == initialVal) { $searchInput.val(opt.text); return false; }
                });

                var altNameKey = fieldDef.key + "AltNames";
                var altNameArr = Array.isArray(currentSettings[altNameKey]) ? currentSettings[altNameKey] : [];
                var altIdx = fieldDef.arrayIndex !== undefined ? fieldDef.arrayIndex : 0;
                var altVal = altNameArr[altIdx];
                var $altInput = $("<input class='dashboard-settings-popup-input dashboard-searchselect-altname'>").attr("type", "text").attr("data-key", altNameKey).attr("data-array-index", altIdx).attr("placeholder", vcDashboardResources.get("altName")).val(altVal || "").css({ width: "100%", boxSizing: "border-box", marginTop: "4px" });

                function renderSearchOptions(filter) {
                    $dropdown.empty();
                    var lowerFilter = (filter || "").toLowerCase();
                    var count = 0;
                    $.each(allOpts, function (j, opt) {
                        if (lowerFilter && opt.text.toLowerCase().indexOf(lowerFilter) === -1) return;
                        count++;
                        var isSelected = opt.value == $hiddenInput.val();
                        var $optDiv = $("<div class='dashboard-searchselect-option'></div>")
                            .text(opt.text)
                            .attr("data-value", opt.value)
                            .css({ padding: "6px 10px", cursor: "pointer", fontWeight: isSelected ? "bold" : "normal" });
                        $optDiv.on("mousedown", function (e) {
                            e.preventDefault();
                            if (opt.value != $hiddenInput.val()) {
                                $altInput.val("");
                            }
                            $hiddenInput.val(opt.value);
                            $searchInput.val(opt.text);
                            $dropdown.hide();
                        });
                        $optDiv.on("mouseenter", function () { $(this).css("background", "var(--color-bg-hover, rgba(255,255,255,0.1))"); });
                        $optDiv.on("mouseleave", function () { $(this).css("background", ""); });
                        $dropdown.append($optDiv);
                    });
                    $dropdown.toggle(count > 0);
                }

                var $clearBtn = $("<div class='dashboard-searchselect-clear'><i class='fa-solid fa-xmark'></i></div>").css({
                    position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)",
                    cursor: "pointer", display: "block", zIndex: 1, color: "#888", fontSize: "14px"
                });
                $clearBtn.on("mousedown", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $searchInput.val("");
                    $altInput.val("");
                    renderSearchOptions("");
                    $searchInput.focus();
                });

                $searchInput.on("focus", function () { renderSearchOptions($(this).val()); });
                $searchInput.on("input", function () {
                    renderSearchOptions($(this).val());
                });
                $searchInput.on("blur", function () {
                    setTimeout(function () {
                        $dropdown.hide();
                        // restore display text of current selection
                        var currentVal = $hiddenInput.val();
                        var foundText = "";
                        $.each(allOpts, function (j, opt) {
                            if (opt.value == currentVal) { foundText = opt.text; return false; }
                        });
                        $searchInput.val(foundText);
                    }, 150);
                });
                $searchInput.css("paddingRight", "28px");

                $searchWrapper.append($hiddenInput, $searchInput, $clearBtn, $dropdown);
                $row.append($label, $searchWrapper, $altInput);
                fieldElements.push($hiddenInput);
                fieldElements.push($altInput);
            } else if (fieldDef.type === "select") {
                var $select = $("<select class='dashboard-settings-popup-input'></select>").attr("data-key", fieldDef.key);
                $.each(fieldDef.options || [], function (j, opt) {
                    var $opt = $("<option></option>").val(opt.value).text(opt.text);
                    if (opt.value == val) $opt.attr("selected", "selected");
                    $select.append($opt);
                });
                $row.append($label, $select);
                fieldElements.push($select);
            } else if (fieldDef.type === "checkbox") {
                var $checkbox = $("<input type='checkbox' class='dashboard-settings-popup-checkbox'>").attr("data-key", fieldDef.key);
                if (val) $checkbox.prop("checked", true);
                $row.addClass("dashboard-settings-popup-row--inline");
                $row.append($checkbox, $label);
                fieldElements.push($checkbox);
            } else if (fieldDef.type === "richtext") {
                var $textarea = $("<textarea class='dashboard-settings-popup-richtext'></textarea>").attr("data-key", fieldDef.key).val(val || "");
                $row.addClass("dashboard-settings-popup-row--richtext");
                $row.append($label, $textarea);
                fieldElements.push($textarea);
                richtextFields.push({ $textarea: $textarea, rows: fieldDef.rows || 10 });
            } else if (fieldDef.type === "number") {
                var $input = $("<input class='dashboard-settings-popup-input'>").attr("type", "number").attr("data-key", fieldDef.key).val(val != null ? val : "").css({ width: "60px", textAlign: "right" });
                if (fieldDef.inline) {
                    $row.addClass("dashboard-settings-popup-row--inline");
                }
                $row.append($label, $input);
                if (fieldDef.suffix) $row.append($("<span class='dashboard-settings-popup-suffix'></span>").text(fieldDef.suffix).css({ marginLeft: "6px" }));
                fieldElements.push($input);
            } else if (fieldDef.type === "signallist") {
                var allOpts = fieldDef.options || [];
                var currentArr = Array.isArray(currentSettings[fieldDef.key]) ? currentSettings[fieldDef.key] : [];
                if (currentArr.length === 0 && allOpts.length > 0) currentArr = [allOpts[0].value];
                var altNameKey = fieldDef.key + "AltNames";
                var currentAltArr = Array.isArray(currentSettings[altNameKey]) ? currentSettings[altNameKey] : [];
                var chartTypeOptions = fieldDef.chartTypeOptions || null;
                var chartTypeKey = fieldDef.key + "ChartTypes";
                var currentChartTypeArr = Array.isArray(currentSettings[chartTypeKey]) ? currentSettings[chartTypeKey] : [];
                var showAxis = !!fieldDef.showAxis;
                var axisOptions = [
                    { value: "left", text: vcDashboardResources.get("axisLeft") },
                    { value: "right", text: vcDashboardResources.get("axisRight") }
                ];
                var axisKey = fieldDef.key + "Axis";
                var currentAxisArr = Array.isArray(currentSettings[axisKey]) ? currentSettings[axisKey] : [];
                var $listContainer = $("<div class='dashboard-signallist-container'></div>").attr("data-key", fieldDef.key).attr("data-field-type", "signallist");

                function createSignalEntry(selectedVal, removable, altName, chartType, axis) {
                    var $entry = $("<div class='dashboard-signallist-entry'></div>").css({ position: "relative", display: "flex", flexDirection: "column", gap: "4px", marginBottom: "4px" });
                    var $entryTop = $("<div></div>").css({ position: "relative", display: "flex", alignItems: "center", gap: "4px" });
                    var $sw = $("<div class='dashboard-searchselect-wrapper'></div>").css({ position: "relative", flex: 1 });
                    var $hi = $("<input type='hidden'>").val(selectedVal || "");
                    var $si = $("<input class='dashboard-settings-popup-input dashboard-searchselect-input' type='text'>").attr({ placeholder: vcDashboardResources.get("search"), autocomplete: "off" }).css({ width: "100%", boxSizing: "border-box", paddingRight: "28px" });
                    var $dd = $("<div class='dashboard-searchselect-dropdown'></div>").css({ position: "absolute", top: "100%", left: 0, right: 0, maxHeight: "200px", overflowY: "auto", background: "#fff", border: "1px solid #555", borderRadius: "4px", zIndex: 1000, display: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.4)" });
                    var $altInput = $("<input class='dashboard-settings-popup-input dashboard-searchselect-altname'>").attr("type", "text").attr("placeholder", vcDashboardResources.get("altName")).val(altName || "").css({ flex: 1, boxSizing: "border-box" });
                    var $chartTypeSelect = null;
                    if (chartTypeOptions && chartTypeOptions.length) {
                        $chartTypeSelect = $("<select class='dashboard-settings-popup-input dashboard-signallist-charttype'></select>");
                        $.each(chartTypeOptions, function (j, opt) {
                            var $opt = $("<option></option>").val(opt.value).text(opt.text);
                            $chartTypeSelect.append($opt);
                        });
                        var initChartType = chartType || chartTypeOptions[0].value;
                        $chartTypeSelect.val(initChartType);
                    }
                    var $axisSelect = null;
                    if (showAxis) {
                        $axisSelect = $("<select class='dashboard-settings-popup-input dashboard-signallist-axis'></select>").css({ flexShrink: 0 });
                        $.each(axisOptions, function (j, opt) {
                            var $opt = $("<option></option>").val(opt.value).text(opt.text);
                            $axisSelect.append($opt);
                        });
                        $axisSelect.val(axis || axisOptions[0].value);
                    }
                    var initVal = selectedVal;
                    if ((initVal == null || initVal === "") && allOpts.length > 0) initVal = allOpts[0].value;
                    $hi.val(initVal || "");
                    $.each(allOpts, function (j, opt) { if (opt.value == initVal) { $si.val(opt.text); return false; } });
                    function renderOpts(filter) {
                        $dd.empty();
                        var lf = (filter || "").toLowerCase(); var count = 0;
                        $.each(allOpts, function (j, opt) {
                            if (lf && opt.text.toLowerCase().indexOf(lf) === -1) return;
                            count++;
                            var isSel = opt.value == $hi.val();
                            var $o = $("<div class='dashboard-searchselect-option'></div>").text(opt.text).attr("data-value", opt.value).css({ padding: "6px 10px", cursor: "pointer", fontWeight: isSel ? "bold" : "normal" });
                            $o.on("mousedown", function (e) {
                                e.preventDefault();
                                if (opt.value != $hi.val()) {
                                    $altInput.val("");
                                }
                                $hi.val(opt.value); $si.val(opt.text); $dd.hide();
                            });
                            $o.on("mouseenter", function () { $(this).css("background", "var(--color-bg-hover, rgba(255,255,255,0.1))"); });
                            $o.on("mouseleave", function () { $(this).css("background", ""); });
                            $dd.append($o);
                        });
                        $dd.toggle(count > 0);
                    }
                    var $cb = $("<div class='dashboard-searchselect-clear'><i class='fa-solid fa-xmark'></i></div>").css({ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", zIndex: 1, color: "#888", fontSize: "14px" });
                    $cb.on("mousedown", function (e) { e.preventDefault(); e.stopPropagation(); $si.val(""); $altInput.val(""); renderOpts(""); $si.focus(); });
                    $si.on("focus", function () { renderOpts($(this).val()); });
                    $si.on("input", function () { renderOpts($(this).val()); });
                    $si.on("blur", function () { setTimeout(function () { $dd.hide(); var cv = $hi.val(); var ft = ""; $.each(allOpts, function (j, opt) { if (opt.value == cv) { ft = opt.text; return false; } }); $si.val(ft); }, 150); });
                    $sw.append($hi, $si, $cb, $dd);
                    $entryTop.append($sw);
                    if ($chartTypeSelect) $entryTop.append($chartTypeSelect);
                    var $actions = $("<div class='dashboard-signallist-entry-actions'></div>");
                    var $upBtn = $("<div class='dashboard-signallist-move-up'><i class='fa-solid fa-arrow-up'></i></div>").css({ cursor: "pointer", color: "#555", fontSize: "12px", display: "flex", alignItems: "center", justifyContent: "center" });
                    $upBtn.on("click", function () {
                        var $prev = $entry.prev(".dashboard-signallist-entry");
                        if ($prev.length) $entry.insertBefore($prev);
                        refreshEntryStates();
                        runAllValidations();
                    });
                    var $downBtn = $("<div class='dashboard-signallist-move-down'><i class='fa-solid fa-arrow-down'></i></div>").css({ cursor: "pointer", color: "#555", fontSize: "12px", display: "flex", alignItems: "center", justifyContent: "center" });
                    $downBtn.on("click", function () {
                        var $next = $entry.next(".dashboard-signallist-entry");
                        if ($next.length) $entry.insertAfter($next);
                        refreshEntryStates();
                        runAllValidations();
                    });
                    var $removeBtn = $("<div class='dashboard-signallist-remove'><i class='fa-solid fa-trash'></i></div>").css({ cursor: "pointer", color: "#c00", fontSize: "12px", display: "flex", alignItems: "center", justifyContent: "center" });
                    $removeBtn.on("click", function () {
                        $entry.remove();
                        refreshEntryStates();
                        runAllValidations();
                    });
                    $actions.append($upBtn, $downBtn, $removeBtn);
                    $entryTop.append($actions);
                    var $entryBottom = $("<div></div>").css({ position: "relative", display: "flex", alignItems: "center", gap: "4px" });
                    $entryBottom.append($altInput);
                    if ($axisSelect) $entryBottom.append($axisSelect);
                    $entry.append($entryTop, $entryBottom);
                    $entry.data("altInput", $altInput);
                    if ($chartTypeSelect) {
                        $entry.data("chartTypeSelect", $chartTypeSelect);
                        $chartTypeSelect.on("change", function () { runAllValidations(); });
                    }
                    if ($axisSelect) {
                        $entry.data("axisSelect", $axisSelect);
                        $axisSelect.on("change", function () { runAllValidations(); });
                    }
                    return $entry;
                }

                function refreshEntryStates() {
                    var $entries = $listContainer.children(".dashboard-signallist-entry");
                    $entries.each(function (idx) {
                        var $e = $(this);
                        var isFirst = idx === 0;
                        var isLast = idx === $entries.length - 1;
                        $e.find(".dashboard-signallist-move-up").css("visibility", isFirst ? "hidden" : "visible");
                        $e.find(".dashboard-signallist-move-down").css("visibility", isLast ? "hidden" : "visible");
                        $e.find(".dashboard-signallist-remove").css("visibility", isFirst ? "hidden" : "visible");
                    });
                }

                $.each(currentArr, function (idx, sigVal) {
                    $listContainer.append(createSignalEntry(sigVal, idx > 0, currentAltArr[idx], currentChartTypeArr[idx], currentAxisArr[idx]));
                });
                refreshEntryStates();

                if (chartTypeOptions && chartTypeOptions.length) {
                    signalListValidators.push(function () {
                        var entries = $listContainer.children(".dashboard-signallist-entry");
                        var hasAbsolute = false, hasPercent = false;
                        var stackedAxes = {};
                        var otherAxes = {};
                        var percentAxis = null;
                        var stackedEntries = [];
                        var otherEntries = [];
                        entries.each(function () {
                            var $e = $(this);
                            var ctSel = $e.data("chartTypeSelect");
                            var axSel = $e.data("axisSelect");
                            var ct = ctSel ? ctSel.val() : null;
                            var ax = axSel ? axSel.val() : "left";
                            if (ct === "stackedabsolute" || ct === "stackedpercent") {
                                stackedAxes[ax] = true;
                                stackedEntries.push({ ct: ctSel, ax: axSel, axisValue: ax, type: ct });
                            } else {
                                otherAxes[ax] = true;
                                otherEntries.push({ ax: axSel, axisValue: ax });
                            }
                            if (ct === "stackedabsolute") hasAbsolute = true;
                            if (ct === "stackedpercent") { hasPercent = true; percentAxis = ax; }
                        });
                        var invalid = [];
                        var message = null;
                        if (hasAbsolute && hasPercent) {
                            message = vcDashboardResources.get("validationStackedMixedTypes");
                            $.each(stackedEntries, function (i, se) { if (se.ct) invalid.push(se.ct); });
                        } else if (Object.keys(stackedAxes).length > 1) {
                            message = vcDashboardResources.get("validationStackedSameAxis");
                            $.each(stackedEntries, function (i, se) { if (se.ax) invalid.push(se.ax); });
                        } else if (hasPercent && otherAxes[percentAxis]) {
                            message = vcDashboardResources.get("validationStackedPercentSeparateAxis");
                            $.each(stackedEntries, function (i, se) { if (se.type === "stackedpercent" && se.ax) invalid.push(se.ax); });
                            $.each(otherEntries, function (i, oe) { if (oe.axisValue === percentAxis && oe.ax) invalid.push(oe.ax); });
                        }
                        if (!message) return null;
                        return { message: message, invalidFields: invalid };
                    });
                }

                var $addBtn = $("<button type='button' class='dashboard-signallist-add'><i class='fa-solid fa-plus'></i> " + vcDashboardResources.get("add") + "</button>").css({ marginTop: "4px", fontSize: "11px", cursor: "pointer", padding: "3px 8px", border: "1px solid #ccc", borderRadius: "3px", background: "#f5f5f5" });
                $addBtn.on("click", function () {
                    $listContainer.find(".dashboard-signallist-add").before(createSignalEntry(null, true));
                    refreshEntryStates();
                    runAllValidations();
                });
                $listContainer.append($addBtn);
                $row.append($label, $listContainer);
                fieldElements.push($listContainer);
            } else {
                var $input = $("<input class='dashboard-settings-popup-input'>").attr("data-key", fieldDef.key).val(val);
                $row.append($label, $input);
                fieldElements.push($input);
            }

            if (fieldDef.breakBefore) {
                $row.css("marginTop", "12px");
            }
            if (fieldDef.breakAfter) {
                $row.css({ paddingBottom: "8px", borderBottom: "1px solid #e0e0e0" });
            }

            if (layout === "twocolumn" && fieldDef.column === "right") {
                $formRight.append($row);
            } else if (layout === "twocolumn") {
                $formLeft.append($row);
            } else {
                $form.append($row);
            }
        });

        // dependsOn: show/hide rows based on another field's value
        $.each(fields, function (i, fieldDef) {
            if (fieldDef.dependsOn) {
                var $depRow = $form.find(".dashboard-settings-popup-row[data-field-index='" + i + "']");
                var depKey = fieldDef.dependsOn.key;
                var depValue = fieldDef.dependsOn.value;
                var $source = $form.find("[data-key='" + depKey + "']");
                function toggleRow() {
                    var v = $source.val();
                    if (v !== "" && !isNaN(v)) v = parseFloat(v);
                    $depRow.toggle(v === depValue);
                }
                $source.on("change", toggleRow);
                toggleRow();
            }
        });

        var $buttons = $("<div class='dashboard-settings-popup-buttons'></div>");
        var $validationMsg = $("<div class='dashboard-settings-popup-validation'></div>").hide();
        var $saveBtn = $("<button class='dashboard-settings-popup-save'>" + vcDashboardResources.get("save") + "</button>");
        var $cancelBtn = $("<button class='dashboard-settings-popup-cancel'>" + vcDashboardResources.get("cancel") + "</button>");
        $buttons.append($saveBtn, $cancelBtn);

        function runAllValidations() {
            $form.find(".dashboard-signallist-charttype, .dashboard-signallist-axis").removeClass("dashboard-settings-popup-input--error");
            var message = null;
            $.each(signalListValidators, function (i, validatorFn) {
                var result = validatorFn();
                if (result) {
                    message = result.message;
                    $.each(result.invalidFields || [], function (j, $field) {
                        $field.addClass("dashboard-settings-popup-input--error");
                    });
                    return false;
                }
            });
            if (message) {
                $validationMsg.text(message).show();
                $saveBtn.prop("disabled", true);
            } else {
                $validationMsg.hide().text("");
                $saveBtn.prop("disabled", false);
            }
            return !message;
        }

        $popup.append($title, $form, $validationMsg, $buttons);
        $overlay.append($popup);
        $("body").append($overlay);

        $.each(richtextFields, function (i, rf) {
            var cl = rf.$textarea.cleditor({
                width: '100%',
                height: (rf.rows * 18),
                controls: 'bold italic underline |  removeformat | bullets numbering'
            })[0];
            cl.change(function () {
                rf.$textarea.val($(cl.doc.body).html());
            });
        });

        runAllValidations();

        $cancelBtn.on("click", function () { $overlay.remove(); });

        $saveBtn.on("click", function () {
            if (!runAllValidations()) return;
            var newSettings = {};
            $.each(fieldElements, function (i, $field) {
                var key = $field.attr("data-key");
                var fieldType = $field.attr("data-field-type");
                var arrayIdx = $field.attr("data-array-index");
                if (fieldType === "signallist") {
                    var arr = [];
                    var altArr = [];
                    var chartTypeArr = [];
                    var axisArr = [];
                    $field.find(".dashboard-signallist-entry").each(function () {
                        var $entry = $(this);
                        var v = $entry.find("input[type='hidden']").val();
                        if (v !== "" && !isNaN(v)) v = parseFloat(v);
                        if (v !== "" && v != null) {
                            arr.push(v);
                            altArr.push($entry.find(".dashboard-searchselect-altname").val() || "");
                            var $ct = $entry.find(".dashboard-signallist-charttype");
                            if ($ct.length) chartTypeArr.push($ct.val());
                            var $ax = $entry.find(".dashboard-signallist-axis");
                            if ($ax.length) axisArr.push($ax.val());
                        }
                    });
                    newSettings[key] = arr;
                    newSettings[key + "AltNames"] = altArr;
                    if (chartTypeArr.length) newSettings[key + "ChartTypes"] = chartTypeArr;
                    if (axisArr.length) newSettings[key + "Axis"] = axisArr;
                } else if ($field.attr("type") === "checkbox") {
                    newSettings[key] = $field.prop("checked");
                } else if (arrayIdx !== undefined && arrayIdx !== "") {
                    var idx = parseInt(arrayIdx);
                    var val = $field.val();
                    var isAltNameField = key && key.indexOf("AltNames") === key.length - "AltNames".length;
                    if (!isAltNameField && val !== "" && !isNaN(val)) val = parseFloat(val);
                    if (!Array.isArray(newSettings[key])) newSettings[key] = currentSettings[key] ? currentSettings[key].slice() : [];
                    newSettings[key][idx] = val;
                } else {
                    var val = $field.val();
                    if (val !== "" && !isNaN(val)) val = parseFloat(val);
                    newSettings[key] = val;
                }
            });
            $overlay.remove();
            onSave(newSettings);
        });
    }

    function getSettings($item, defaults) {
        var currentSettings = {};
        try { currentSettings = JSON.parse($item.attr("data-settings") || "{}"); } catch (ex) { }
        return $.extend({}, defaults, currentSettings);
    }

    function getApi($item) {
        var $el = $item.closest(".vc-dashboard-wrapper").parent();
        return $el.data("vcDashboard");
    }

    function getSignalOptions($item) {
        var api = getApi($item);
        var signals = (api && api.getSignals) ? api.getSignals() : [];
        return $.map(signals, function (sig) {
            var id = sig.signalid || sig.id;
            var name = sig.Name || sig.name || "";
            var unit = sig.Unit || sig.dims || "";
            return { value: id, text: name + (unit ? " [" + unit + "]" : "") };
        });
    }

    function findSignal($item, signalId) {
        var api = getApi($item);
        var signals = (api && api.getSignals) ? api.getSignals() : [];
        var signal = null;
        if (signalId) {
            $.each(signals, function (i, sig) {
                var id = sig.signalid || sig.id;
                if (id == signalId) { signal = sig; return false; }
            });
        }
        return signal;
    }

    function updateWidgetHeader($item, title) {
        var text = (title || "").toString().trim();
        var $header = $item.children(".dashboard-widget-header");
        if (!$header.length) {
            $header = $("<div class='dashboard-widget-header'></div>");
            $item.prepend($header);
        }
        if (text) {
            $header.text(text).show();
        } else {
            $header.empty().hide();
        }
    }

    function initSettingsButton($item, plugin, buildFieldsFn, onAfterSave) {
        if (!plugin.defaults.showSettings) return;
        addSettingsButton($item, function () {
            var currentSettings = getSettings($item, plugin.settingsDefaults || {});
            var fields = buildFieldsFn.call(plugin, currentSettings, $item);
            if (!plugin.noTitle) {
                fields = [{ key: "Title", label: vcDashboardResources.get("widgetTitle"), type: "text" }].concat(fields);
            }

            open({
                title: plugin.popupTitle || vcDashboardResources.get("settings"),
                layout: plugin.popupLayout || "single",
                wide: !!plugin.popupWide,
                settings: currentSettings,
                fields: fields,
                onSave: function (newSettings) {
                    if (currentSettings.LoggerId) newSettings.LoggerId = currentSettings.LoggerId;
                    if (currentSettings.Day) newSettings.Day = currentSettings.Day;
                    $item.attr("data-settings", JSON.stringify(newSettings));
                    if (!plugin.noTitle) updateWidgetHeader($item, newSettings.Title);
                    var api = getApi($item);
                    if (onAfterSave) onAfterSave.call(plugin, $item, newSettings, api);
                    if (api && api.saveConfig) api.saveConfig();
                }
            });
        });
    }

    function initPlugin($item, plugin, settings) {
        if (!plugin.noTitle) {
            updateWidgetHeader($item, settings.Title);
        }
        if (typeof plugin.onLoad === "function") {
            plugin.onLoad($item, settings);
        }
        if (typeof plugin.buildFields === "function" && typeof plugin.onSettingsSave === "function") {
            initSettingsButton($item, plugin, plugin.buildFields, plugin.onSettingsSave);
        }
    }

    function resolveEffectiveSettings($item, settings) {
        var effectiveSettings = $.extend({}, settings);
        effectiveSettings.DateUserDef = false;
        var api = getApi($item);
        var status = api ? api.getSettings().Status : null;

        if (effectiveSettings.Interval === 0) {


            var menuInterval = (status && status.menu) ? status.menu.interval : 1;
            switch (menuInterval) {
                case 3: effectiveSettings.Interval = 2; break;
                case 5: effectiveSettings.Interval = 3; break;
                default: effectiveSettings.Interval = 1; break;
            }
        }
        if (status && status.date && status.date.isSingle === false && status.date.dateRange) {
            effectiveSettings.StartDate = status.date.dateRange.from;
            effectiveSettings.EndDate = status.date.dateRange.to;
            effectiveSettings.DateUserDef = true;
        }
        return { effectiveSettings: effectiveSettings, status: status };
    }

    function buildChartParams(settings, status) {

       


        var signalIds = (settings.SignalIds && settings.SignalIds.length > 0) ? settings.SignalIds : [];
        var signalAltNames = Array.isArray(settings.SignalIdsAltNames) ? settings.SignalIdsAltNames : [];
        var signalChartTypes = Array.isArray(settings.SignalIdsChartTypes) ? settings.SignalIdsChartTypes : [];
        var signalAxis = Array.isArray(settings.SignalIdsAxis) ? settings.SignalIdsAxis : [];
        var signalParam = { 'series': [] };
        $.each(signalIds, function (i, sigId) {
            var altName = signalAltNames[i];
            var seriesType = signalChartTypes[i] || settings.ChartType || 'spline';
            var axisPosition = signalAxis[i] || 'left';
            signalParam.series.push({ bsaid: [sigId], AltName: [altName || ""], rule: '[bsaid=' + sigId + ']', ruleType: 1, seriesType: seriesType, AxisPosition: axisPosition });
        });

        var today = new Date();
        var todayStr = today.getDate() + '.' + (today.getMonth() + 1) + '.' + today.getFullYear();

       
        var singleDate = status.date.singleDate || todayStr;
        var visualName = "";
        var dataType = 1;
        var dateUserDef = settings.DateUserDef;
        var interval = 1;
        var start, end;

        switch (settings.Interval) {
            case 0:
            case 1:
                visualName = "VISUAL_RAMP_SINGLE";
                dataType = 1;
                interval = 1;
                break;
            case 2:
                visualName = "VISUAL_RAMP_DAILY";
                dataType = 2;
                interval = 3;
                break;
            case 3:
                visualName = "VISUAL_RAMP_MONTHLY";
                dataType = 2;
                interval = 5;
                break;
            //default:
            //    visualName = "VISUAL_RAMP_SINGLE";
            //    dataType = 1;
            //    break;
        }
        

        if (settings.StartDate && settings.EndDate) {

            start = settings.StartDate;
            end = settings.EndDate;
        } else {
            var parts = singleDate.split('.');
            var day = parseInt(parts[0]);
            var month = parseInt(parts[1]);
            var year = parseInt(parts[2]);
            switch (settings.Interval) {
                case 2:
                    start = '1.' + month + '.' + year;
                    end = new Date(year, month, 0).getDate() + '.' + month + '.' + year;
                    break;
                case 3:
                    start = '1.1.' + year;
                    end = '31.12.' + year;
                    break;
                default:
                    start = singleDate;
                    end = singleDate;
                    break;
            }
        }

      


        //
        var param = {
            'loggerID': settings.LoggerId, 'ShowInvalidValues': true, 'ShowPlotLines': true, DateUserDef: dateUserDef, interval: interval, 'datatype': dataType, 'startDate': start, 'endDate': end, 'NoZoom': false, ShowExportIcons: false,
            'ShowEmptyChart': true, 'ShowUnsmoothedValues': true, 'HideNotAllowedIntervals': false, "ShowIntervention": true, 'UseSimpleBottomLegend': true, UseWidgetHeaderDate: false,
            'IsCumulated': settings.IsCumulated || false
        };
        
      

        var comparisonMode = settings.ComparisonMode || 0;
        switch (comparisonMode) {
            case 0:
                break;
            case 1:
                if (status && status.date) {
                    switch (status.date.dateComparisonType) {
                        case 0:
                            param.AutoComparisonInterval = parseInt(status.date.flexibleInterval);
                            
                            break;
                        case 1:
                            param.compareStartDate = status.date.dateRangeComparison.from;
                            param.compareEndDate = status.date.dateRangeComparison.to;
                            param.DateUserDef = true;
                            break;
                        case 2:
                            param.AutoPreviousPeriodComparison = true;
                            break;
                    }
                }
                break;
            case 2:
                param.AutoComparisonInterval = parseInt(settings.ComparisonOffset);
                break;
        }

        var priceCo2 = settings.PriceCo2 || 0;
        switch (priceCo2) {
            case 0:
                break;
            case 1:
                param.usePrices = true;

                break;
            case 2:
                param.usePrices = true;
                param.useCo2AsPrice = true;
                break;
        }

        return { Param: param, SignalParam: signalParam, VisualName: visualName };
    }

    return {
        formatNumber: formatNumber,
        addSettingsButton: addSettingsButton,
        open: open,
        getSettings: getSettings,
        getApi: getApi,
        getSignalOptions: getSignalOptions,
        findSignal: findSignal,
        initSettingsButton: initSettingsButton,
        initPlugin: initPlugin,
        updateWidgetHeader: updateWidgetHeader,
        resolveEffectiveSettings: resolveEffectiveSettings,
        buildChartParams: buildChartParams
    };

})(jQuery);